import { AblyService } from '../common/services/AblyService';
import { queryClient } from '../lib/queryClient';
import { RoleService } from '../user/session/RoleService';

import { TokenManager } from './TokenManager';

export const clearUserSession = (): void => {
    AblyService.disconnect();
    TokenManager.getInstance().clear();
    RoleService.getInstance().reset();
    queryClient.clear();
};
